import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { omitProps, deriveStateFromWatchedProps } from 'utils/react';
import { propTypes, defaultProps } from './propTypes';
import ToggleableContext from './ToggleableContext';

export default class Toggleable extends Component {
    static displayName = 'Toggleable';

    static propTypes = {
        wrappedComponent: PropTypes.func.isRequired,
        ...propTypes,
    };

    static contextType = ToggleableContext;

    static defaultProps = {
        ...defaultProps,
    };

    static getDerivedStateFromProps(props, state) {
        return deriveStateFromWatchedProps(props, state, {
            isOpen: null,
        });
    }

    state = {
        isOpen: null,
    };

    componentDidUpdate(previousProps, previousState) {
        const { onBeforeOpen, onBeforeClose } = this.props;
        const { isOpen } = this.state;

        if (previousState.isOpen !== isOpen) {
            if (isOpen && onBeforeOpen) {
                onBeforeOpen();
            } else if (!isOpen && onBeforeClose) {
                onBeforeClose();
            }
        }
    }

    getContext() {
        const { onBeforeOpen, onOpen, onBeforeClose, onClose } = this.props;
        const { isOpen } = this.state;

        return {
            isOpen,
            onBeforeOpen,
            onOpen,
            onBeforeClose,
            onClose,
            open: this.open,
            close: this.close,
            toggle: this.toggle,
        };
    }

    setOpen(isOpen, callback) {
        const { isOpen: isOpenState } = this.state;
        if (isOpen !== isOpenState) {
            this.setState({ isOpen }, () => {
                if (typeof callback === 'function') {
                    callback();
                }
            });
        }
    }

    toggle = (callback) => {
        const { isOpen } = this.state;
        if (isOpen) this.close(callback);
        else this.open(callback);
    };

    open = (callback) => {
        this.setOpen(true, callback);
    };

    close = (callback) => {
        this.setOpen(false, callback);
    };

    renderComponent() {
        const { wrappedComponent: ToggleableComponent, innerRef, ...rest } = this.props;

        return <ToggleableComponent {...omitProps(rest, Toggleable)} ref={innerRef} />;
    }

    render() {
        return (
            <ToggleableContext.Provider value={this.getContext()}>
                {this.renderComponent()}
            </ToggleableContext.Provider>
        );
    }
}
